import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import { AuthPopupHOC } from "@/_MiniApps/auth/AuthContext";
import { useMemo } from "react";
import banners from "@data/banners/login-pages/saved_search.json";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useCMS } from "@hooks/useCMS";
import { trackEvents } from "@/common/events/events";
import { toast } from "sonner";
import { TAG_TYPES } from "@/pages/saved-search/saved-search";
import useFilterPage, { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
var SaveSearchBanner = function SaveSearchBanner() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var _useSearchResultsData = useSearchResultsData(),
    selectedOptions = _useSearchResultsData.selectedOptions;
  var _useFilterPage = useFilterPage(),
    handleSaveFilters = _useFilterPage.handleSaveFilters;
  var authScreenDesign = useMemo(function () {
    return {
      banners: {
        desktop: imageUrl(banners[lang].desktop_images[0]),
        mobile: imageUrl(banners[lang].mobile_images[0])
      },
      title: t("log_create_account", {
        ns: "web_common"
      }),
      description: t("save_search_adding_phone_number", {
        ns: "web_common"
      })
    };
  }, []);
  var handleClickSave = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _res$data, res, _res$data2, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            trackEvents("element_click", {
              element_name: "save_search",
              user_login_status: "true"
            });
            _context.p = 1;
            _context.n = 2;
            return handleSaveFilters();
          case 2:
            res = _context.v;
            if (!((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.success) === true)) {
              _context.n = 3;
              break;
            }
            toast.success(t('search_saved_access_account_list', {
              ns: "saved_search"
            }), {
              position: "top-center",
              duration: 5000,
              style: {
                zIndex: 9999999
              }
            });
            trackEvents("save_search_click", {
              filter_count: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length,
              filter_name: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function (option) {
                var property = {};
                if (option.type === TAG_TYPES.RANGE) {
                  property[option.filterField] = "".concat(option.range_values.from, "-").concat(option.range_values.to);
                } else {
                  property[option.filterField] = option.name_en;
                }
                return property;
              })
            });
            _context.n = 4;
            break;
          case 3:
            throw new Error((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.errors) || "something went wrong");
          case 4:
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            console.log(_t.message);
            toast.error(_t.message, {
              position: "bottom-center",
              style: {
                zIndex: 9999999
              }
            });
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[1, 5]]);
    }));
    return function handleClickSave() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthPopupHOC, {
    customModalClassName: "modalHideHeader",
    authScreenDesign: authScreenDesign,
    onCancel: function onCancel() {
      trackEvents("element_click", {
        element_name: "save_search",
        user_login_status: "false"
      });
    },
    renderFunc: function renderFunc(checkAuth) {
      return /*#__PURE__*/React.createElement("div", {
        id: "filter-save-search-banner",
        className: "bg-blue-water py-2 px-3 rounded flex items-center justify-between",
        onClick: function onClick() {
          return checkAuth(handleClickSave);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-1"
      }, /*#__PURE__*/React.createElement("img", {
        className: "w-6 h-6",
        src: CDN_LINK + "/assets/images/save.svg",
        alt: "save"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-gray-text text-sm font-semibold"
      }, t("save_search", {
        ns: "saved_search"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "text-blue-old"
      }, /*#__PURE__*/React.createElement("span", {
        id: "filter-save-search-btn",
        className: "text-xs font-bold underline cursor-pointer"
      }, t("save_search_2", {
        ns: "saved_search"
      }))));
    }
  }));
};
export default SaveSearchBanner;